import React, { Fragment } from 'react'
import CreateFeatureGroupMutation from 'components/mutations/CreateFeatureGroup'
import PageHeader from 'components/PageHeader'
import { compose } from 'utils/fp'
import { object, string } from 'yup'
import { parseMessages } from 'utils/graphql'
import { ButtonLink, Form, UsersIcon } from 'stylist'

const schema = object({
  name: string().required("Name can't be blank")
})

const capitalize = errors => errors[0].toUpperCase() + errors.slice(1)

const RouteAdminFeaturesGroupsNew = () => (
  <Fragment>
    <PageHeader columns="auto 1fr">
      <PageHeader.Icon>
        <UsersIcon />
      </PageHeader.Icon>
      <PageHeader.Title>New Group</PageHeader.Title>
    </PageHeader>
    <article>
      <CreateFeatureGroupMutation>
        {({ createFeatureGroup }) => (
          <Form
            initialValues={{ name: '' }}
            redirect="/admin/features/groups"
            validationSchema={schema}
            serializeErrors={compose(capitalize, parseMessages)}
            onSubmit={createFeatureGroup}
          >
            <Form.Errors />
            <Form.Group>
              <Form.Label htmlFor="name">Name</Form.Label>
              <Form.Input type="text" name="name" />
            </Form.Group>
            <Form.Group buttons>
              <ButtonLink kind="ghost" to="/admin/features/groups">
                Cancel
              </ButtonLink>
              <Form.SubmitButton>Submit</Form.SubmitButton>
            </Form.Group>
          </Form>
        )}
      </CreateFeatureGroupMutation>
    </article>
  </Fragment>
)

export default RouteAdminFeaturesGroupsNew



// WEBPACK FOOTER //
// ./src/routes/admin/features/groups/new.js